import * as React from "react";
import { Button, Classes, Collapse, Dialog, } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observer } from "mobx-react";
import { createViewModel, IViewModel } from "mobx-utils";
import { IEmpresa, newEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { observable } from "mobx";
import LoadingModal from "../loading/LoadingModal";
import { AppIcon } from "../utils/AppIcon";
import Tour from "reactour";
import { toast } from "react-toastify";
import { FAIXAS_BASE, LIMITE_MAXIMO } from "../../utils";

require("../../assets/css/empresa.css")

interface IEmpresaFormProps { }

@observer
export default class EmpresaCreatePlan extends React.Component<IEmpresaFormProps, any> {

  obs = observable({
    empresa: {} as IEmpresa & IViewModel<IEmpresa>,
    detalhes_import_planilha: false as boolean,
    showErrors: false as boolean,
    showSuccess: false as boolean,
    resp_data: [] as any,

    mask_cnpj: "",
    rendimento: "",
    fileUploaded: null,
    route: null,
    rendNum: null,
    acimaDolimite: null,
    planCalc: { faixa: 1, maximo: 100000, minimo: 0, valor: 19.9, armazenamento: 200 },
    pColor: "",
    pLabel: "",
    cnpjOk: false,
    tabelaAberta: false
  })

  fileInputRef: any;

  constructor(props: IEmpresaFormProps) {
    super(props);

    AppStore.setTitle("");
    this.obs.empresa = createViewModel(newEmpresa());
    EmpresaStore.obs.valorPlano = null;
    EmpresaStore.obs.cnpj = ""
    this.fileInputRef = React.createRef();
  }

  async componentDidMount() {

    EmpresaStore.obs.working = false;

    await EmpresaStore.count_empresas();

    this.obs.empresa = createViewModel(newEmpresa());
    this.obs.pColor = this.obs.planCalc ? this.planColor(this.obs.planCalc.faixa) : "#3579ea";
    this.obs.pLabel = this.obs.planCalc ? this.planLabel(this.obs.planCalc.faixa) : "—";

    this.setState({ filial: "" });

    this.forceUpdate();

    let contaPermissao = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;
    let totalEmpresas = EmpresaStore.obs.count_empresas

    if (contaPermissao && totalEmpresas > 1) {
      return AppStore.setLocation("/empresas");
    }

    if (totalEmpresas < 4) {
      EmpresaStore.obs.isTourOpen = true
    }

  }

  handleConsultaCNPJ = async () => {

    EmpresaStore.obs.isTourOpen = false

    let is_teste = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;

    let cnpjEmpresa = EmpresaStore.obs.cnpj;

    EmpresaStore.obs.valorPlano = this.obs.planCalc.faixa;

    EmpresaStore.obs.plano = this.obs.planCalc;

    if (is_teste) {

      EmpresaStore.obs.valorPlano = 1;

      EmpresaStore.obs.plano = { faixa: 1, maximo: 100000, minimo: 0, valor: 19.9, armazenamento: 200 };

    }

    await EmpresaStore.buscaCNPJ(cnpjEmpresa);

  };

  handleClick = () => {

    window.open(`https://api.whatsapp.com/send?phone=54991893928&text=Ol%C3%A1!%20Gostaria%20de%20saber%20mais%20sobre%20os%20planos%20personalizados%20para%20empresas%20com%20rendimentos%20superiores%20a%2010%20milh%C3%B5es.`, '_blank');

  };

  handleExport = async () => {

    await EmpresaStore.exportPlanilhaModelo();

  };

  handleImport = async (e: File) => {

    let is_teste = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;

    if (is_teste) return toast.error('Você não tem permissão para importar no período de testes.', {});

    const resp = await EmpresaStore.importPlanilhaEmpresa(e);

    if (resp && resp.ok) {

      this.obs.resp_data = resp;

      this.obs.resp_data.erros = resp.erros.map((erro) => {
        const campos = Object.keys(erro).filter(key => key !== "mensagem");
        const nomeCampo = campos[0];
        const valorCampo = erro[nomeCampo];

        return `${nomeCampo.toUpperCase()} : ${valorCampo} - ${erro.mensagem}`;
      });

      this.obs.detalhes_import_planilha = true;

    }

  };

  handleShowErrors() {

    this.obs.showErrors = !this.obs.showErrors

    this.obs.showSuccess = false

  }

  handleShowSuccess() {

    this.obs.showSuccess = !this.obs.showSuccess

    this.obs.showErrors = false

  }

  handleRend(val: string) {

    this.obs.rendimento = this.maskMoney(val)
    EmpresaStore.obs.rendimento_mensal = this.parseMoney(this.obs.rendimento)

    this.obs.acimaDolimite = EmpresaStore.obs.rendimento_mensal > LIMITE_MAXIMO;

    this.obs.planCalc = (EmpresaStore.obs.rendimento_mensal >= 0 && !this.obs.acimaDolimite ? this.calcPlano(EmpresaStore.obs.rendimento_mensal) : null)

    this.obs.pColor = this.obs.planCalc ? this.planColor(this.obs.planCalc.faixa) : "#3579ea";
    this.obs.pLabel = this.obs.planCalc ? this.planLabel(this.obs.planCalc.faixa) : "—";

  }

  handleCnpj(val: string) {

    this.obs.mask_cnpj = this.maskCnpj(val)

    EmpresaStore.obs.cnpj = this.obs.mask_cnpj.replace(/\D/g, "")

    this.obs.cnpjOk = this.obs.mask_cnpj.replace(/\D/g, "").length === 14;

  }

  calcPlano(rendimento: number) {

    if (rendimento > LIMITE_MAXIMO) return null;

    return FAIXAS_BASE.find(f => rendimento <= f.maximo) || null;

  }

  planColor(faixa: number) {
    if (faixa <= 2) return "#3579ea";
    if (faixa <= 4) return "#8b5cf6";
    if (faixa <= 6) return "#0ea5e9";
    if (faixa <= 9) return "#f59e0b";
    if (faixa <= 11) return "#f97316";
    return "#dc2626";
  }

  planLabel(faixa: number) {
    if (faixa <= 2) return "Starter";
    if (faixa <= 4) return "Básico";
    if (faixa <= 6) return "Profissional";
    if (faixa <= 9) return "Avançado";
    if (faixa <= 11) return "Premium";
    if (faixa <= 13) return "Enterprise";
    return "Enterprise+";
  }

  fmtMoney = (v: number) =>
    "R$ " + v.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  fmtStorage = (mb: number) => (mb >= 1024 ? mb / 1024 + " GB" : mb + " MB");

  maskMoney(raw: string) {
    const digits = raw.replace(/\D/g, "");
    if (!digits) return "";
    const n = (parseInt(digits) / 100).toFixed(2);
    return "R$ " + n.replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  parseMoney(v: string) {
    return parseFloat(v.replace(/[R$\s.]/g, "").replace(",", ".")) || 0;
  }

  maskCnpj(v: string) {
    v = v.replace(/\D/g, "").slice(0, 14);
    if (v.length <= 2) return v;
    if (v.length <= 5) return v.replace(/(\d{2})(\d+)/, "$1.$2");
    if (v.length <= 8) return v.replace(/(\d{2})(\d{3})(\d+)/, "$1.$2.$3");
    if (v.length <= 12) return v.replace(/(\d{2})(\d{3})(\d{3})(\d+)/, "$1.$2.$3/$4");
    return v.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d+)/, "$1.$2.$3/$4-$5");
  }

  renderExcel(is_teste: boolean) {
    return (
      <div className="excel-container">
        {[
          { n: 1, label: "Baixar modelo", sub: "Planilha Excel com o formato correto" },
          { n: 2, label: "Importar planilha preenchida", sub: "Faça upload do arquivo .xlsx com os dados" },
        ].map(({ n, label, sub }) => (
          <div key={n} className="step-card">
            <div className="step-header">
              <div className="step-number">
                <span className="step-number-text">{n}</span>
              </div>
              <div>
                <div className="step-label">{label}</div>
                <div className="step-sublabel">{sub}</div>
              </div>
            </div>

            {n === 1 && (
              <div className="file-download-area">
                <div className="file-info">
                  <AppIcon name="docs" size={20} color="#22c55e" />
                  <div>
                    <div className="file-name">modelo_empresas.xlsx</div>
                    <div className="file-meta">12 KB · Excel</div>
                  </div>
                </div>
                <button disabled={is_teste} className="bp btn-download" onClick={() => !is_teste && this.handleExport()}>
                  <AppIcon name="download" size={13} color="#fff" />Baixar modelo
                </button>
              </div>
            )}

            {n === 2 && (
              <div
                className={!is_teste ? "uz upload-zone" : "upload-zone"}
                onClick={() => this.fileInputRef.current?.click()}
                onDragOver={e => { e.preventDefault(); e.currentTarget.style.borderColor = "#3579ea"; }}
                onDragLeave={e => { e.currentTarget.style.borderColor = "#e8eaed"; }}
                onDrop={e => {
                  e.preventDefault();
                  e.currentTarget.style.borderColor = "#e8eaed";
                  if (!is_teste) {
                    const f = e.dataTransfer.files[0];
                    if (f) this.handleImport(f);
                  }
                }}>
                <input disabled={is_teste} ref={this.fileInputRef} type="file" accept=".xlsx" className="hidden-input" onChange={e => {
                  if (!is_teste) {
                    const f = e.target.files[0];
                    if (f) this.handleImport(f);
                    e.target.value = "";
                  }
                }} />
                <div className="upload-icon-area">
                  <AppIcon name="upload" size={28} color="#94a3b8" />
                </div>
                <div className="upload-text">Clique para selecionar</div>
                <div className="upload-hint">Somente .xlsx</div>
              </div>
            )}
          </div>
        ))}

      </div>
    )

  }

  renderManual(is_teste: boolean) {
    return (
      <div className="manual-container">
        <div data-tut="faturamento_teste" key={1} className={`step-card ${is_teste ? "step-card--teste" : ""}`} style={{ pointerEvents: "auto" }}>
          {is_teste && (
            <div className="blocked-overlay">
              <span className="blocked-badge">
                Indisponível no modo teste
              </span>
            </div>
          )}
          <div className="step-header">
            <div className="step-number">
              <span className="step-number-text">1</span>
            </div>
            <div>
              <div className="step-label">Rendimento Mensal Bruto</div>
              <div className="step-sublabel">Determina automaticamente o plano e o valor</div>
            </div>
          </div>
          <input
            data-tut="faturamento"
            disabled={EmpresaStore.obs.buscando_cnpj || is_teste}
            className="fi input-rendimento"
            value={this.obs.rendimento}
            onChange={e => this.handleRend(e.target.value)}
            placeholder="R$ 0,00"
            style={{ border: `1px solid ${this.obs.acimaDolimite ? "#dc2626" : EmpresaStore.obs.rendimento_mensal ? "#3579ea" : "#e2e5ea"}` }}
          />

          {this.obs.acimaDolimite && (
            <div className="warning-box">
              <svg width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="warning-icon"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>
              <div>
                <div className="warning-title">Rendimento acima do limite</div>
                <div className="warning-text">Empresas com rendimentos superiores a R$ 10.000.000,00 devem entrar em contato com o suporte para mais informações e personalização do plano.</div>
              </div>
            </div>
          )}

          {this.obs.planCalc && (
            <div data-tut="plano" className="plan-badge" style={{ background: this.obs.pColor + "0e", border: `1px solid ${this.obs.pColor}28` }}>
              <div className="plan-badge-header">
                <div className="plan-badge-info">
                  <AppIcon name="bolt" size={15} color={this.obs.pColor} />
                  <div>
                    <div className="plan-label" style={{ color: this.obs.pColor }}>Faixa {this.obs.planCalc.faixa}</div>
                    <div className="plan-range">{this.fmtMoney(this.obs.planCalc.minimo)} – {this.fmtMoney(this.obs.planCalc.maximo)}/mês</div>
                  </div>
                </div>
                <div className="plan-price-area">
                  <div className="plan-price" style={{ color: this.obs.pColor }}>{this.fmtMoney(this.obs.planCalc.valor)}</div>
                  <div className="plan-per-month">/mês</div>
                </div>
              </div>
              <div className="plan-storage" style={{ borderTop: `1px solid ${this.obs.pColor}20` }}>
                <AppIcon name="hard_drive" size={13} color={this.obs.pColor} />
                <span className="storage-label">Armazenamento incluído:</span>
                <span className="storage-value" style={{ color: this.obs.pColor }}>{this.fmtStorage(this.obs.planCalc.armazenamento)}</span>
              </div>
            </div>
          )}

        </div>

        <div key={2} className="step-card">
          <div className="step-header">
            <div className="step-number">
              <span className="step-number-text">2</span>
            </div>
            <div>
              <div className="step-label">CNPJ da Empresa</div>
              <div className="step-sublabel">Consulta automática na Receita Federal ao completar o CNPJ</div>
            </div>
          </div>
          <div className="opacity-transition" style={{ opacity: (this.obs.planCalc && !this.obs.acimaDolimite) ? 1 : 0.38, pointerEvents: (this.obs.planCalc && !this.obs.acimaDolimite) ? "auto" : "none" }}>
            <div className="cnpj-wrapper">
              <div className="cnpj-icon">
                <AppIcon name="search" size={15} color="#94a3b8" />
              </div>
              <input
                data-tut="cnpj"
                disabled={EmpresaStore.obs.disable_input_cnpj}
                className="fi ci input-cnpj"
                value={this.obs.mask_cnpj}
                onChange={e => this.handleCnpj(e.target.value)}
                placeholder="00.000.000/0000-00"
              />
            </div>
          </div>
        </div>

        <button
          data-tut="continuar"
          className={`bp btn-continuar ${(this.obs.planCalc && this.obs.cnpjOk) ? "btn-continuar--active" : "btn-continuar--disabled"}`}
          onClick={() => this.handleConsultaCNPJ()}
          disabled={!(this.obs.planCalc && this.obs.cnpjOk) && !EmpresaStore.obs.working}
        >
          {EmpresaStore.obs.working
            ? "Consultando..."
            : <>
              <AppIcon name="arrow_forward" size={16} color={(this.obs.planCalc && this.obs.cnpjOk) ? "#fff" : "#94a3b8"} />
              Continuar
            </>}
        </button>

      </div>
    )
  }

  render() {

    let is_teste = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;

    return (
      <>

        <Tour
          onRequestClose={() => EmpresaStore.obs.isTourOpen = false}
          steps={is_teste ? tourTestConfig : tourConfig}
          isOpen={EmpresaStore.obs.isTourOpen}
          disableFocusLock={true}
          disableInteraction={false}
          rounded={is_teste ? 3 : 4}
        />

        <div className="empresa-container">

          {!this.obs.route && <>
            <div className="empresa-header">
              <h1 className="empresa-title">Como deseja cadastrar sua empresa?</h1>
              <p className="empresa-subtitle">Escolha a forma mais adequada para o seu caso</p>
            </div>

            <div className="route-grid">
              {[
                { id: "excel", cor: "#22c55e", icon: "table", title: "Importar Planilha", desc: "Baixe o modelo em Excel, preencha com os dados das empresas e importe todas as informações de uma só vez.", body: this.renderExcel(is_teste) },
                { id: "manual", cor: "#3579ea", icon: "edit_square", title: "Cadastro Manual", desc: "Informe primeiro o seu rendimento mensal para que o plano seja calculado automaticamente. Em seguida, insira o CNPJ.", body: this.renderManual(is_teste) },
              ].map(r => {
                const bloqueado = is_teste && r.id === "excel";
                return (
                  <div
                    key={r.id}
                    className={`rc route-card ${bloqueado ? "route-card--blocked" : ""}`}
                  >
                    {bloqueado && (
                      <div className="blocked-overlay">
                        <span className="blocked-badge">
                          Indisponível no modo teste
                        </span>
                      </div>
                    )}
                    <div className="route-card-bar" style={{ background: r.cor }} />
                    <h2 className="route-card-title">{r.title}</h2>
                    <p className="route-card-desc">{r.desc}</p>
                    {r.body}
                  </div>
                );
              })}

            </div>

            <div style={{ marginTop: 16 }}>
              <button onClick={() => this.obs.tabelaAberta = (!this.obs.tabelaAberta)} className="btn-faixas-toggle">
                <span className="btn-faixas-toggle-label">
                  <AppIcon name="sell" size={14} color="#3579ea" /> Ver todas as faixas de plano
                </span>
                {this.obs.tabelaAberta ? <AppIcon name="keyboard_arrow_up" size={14} color="#94a3b8" /> : <AppIcon name="keyboard_arrow_down" size={14} color="#94a3b8" />}
              </button>
            </div>

          </>}

          <Dialog isOpen={this.obs.tabelaAberta} title="Faixas e Planos" onClose={() => this.obs.tabelaAberta = false}>
            <div className={Classes.DIALOG_BODY}>
              <div className="faixas-table-container">
                <table className="faixas-table">
                  <thead>
                    <tr className="faixas-thead-row">
                      {["Faixa", "Rendimento Mensal", "Valor/mês", "Armazenamento"].map(h => (
                        <th key={h} className={`faixas-th ${h === "Faixa" || h === "Rendimento Mensal" ? "faixas-th--left" : "faixas-th--right"}`}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {FAIXAS_BASE.map(f => {
                      const ativo = this.obs.planCalc?.faixa === f.faixa;
                      const c = this.planColor(f.faixa);
                      return (
                        <tr key={f.faixa} className="trow faixas-tr" style={{ background: ativo ? c + "0d" : "transparent" }}>
                          <td className="faixas-td">
                            <span className="faixa-badge" style={{ color: c, background: c + "18" }}>{f.faixa}</span>
                          </td>
                          <td className="faixas-td faixas-td-rendimento">{this.fmtMoney(f.minimo)} – {this.fmtMoney(f.maximo)}</td>
                          <td className="faixas-td faixas-td--right">
                            <span className="faixa-valor" style={{ color: c }}>{this.fmtMoney(f.valor)}</span>
                          </td>
                          <td className="faixas-td faixas-td--right faixas-td-storage">{this.fmtStorage(f.armazenamento)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <div className="warn-rendimento10">
                <AppIcon name="warning" size={20} color="#f59e0b" />
                <div>
                  <div className="warning-title">
                    Rendimento acima de R$ 10.000.000,00?
                  </div>
                  <div className="warning-text">
                    Empresas com rendimentos superiores a esse valor devem entrar em contato com o suporte
                    para mais informações e personalização do plano.
                  </div>
                </div>
              </div>
            </div>
          </Dialog>

          <Dialog isOpen={this.obs.detalhes_import_planilha} title="Detalhes da Importação" onClose={() => { this.obs.detalhes_import_planilha = false; this.obs.showErrors = false }} className={this.obs.showErrors ? "import_error" : "import_pass"} >
            <div className={Classes.DIALOG_BODY}>
              <MDBRow>
                <MDBCol md="5">
                  <div>
                    <h3 className="arquivosProcessados">
                      <span className="roundCount">{this.obs.resp_data.total_dados}</span>{" "}
                      Total de cadastros
                    </h3>
                    <h3 className="arquivosProcessados">
                      <span className="roundCount">{this.obs.resp_data.importados}</span>{" "}
                      Cadastros importados
                    </h3>
                    <h3 className="arquivosProcessados">
                      <span className={(this.obs.resp_data.total_erros >= 1)
                        ? "roundCount roundCountError"
                        : "roundCount roundNotError"}
                      > {this.obs.resp_data.total_erros}</span>{" "}
                      Linha(s) com erro(s)
                    </h3>
                    {this.obs.resp_data.total_erros ?
                      <MDBBtn
                        onClick={() => this.handleShowErrors()}
                        className="btnDefault btnBuscarNfe erroCalculoBtn"
                        style={{ marginTop: 25, marginRight: 25 }}
                      >
                        {this.obs.showErrors ? "Ocultar" : "Mostrar"} erros
                      </MDBBtn> : <>
                      </>
                    }
                    {this.obs.resp_data.importados ?
                      <MDBBtn
                        onClick={() => this.handleShowSuccess()}
                        className="btnDefault btnBuscarNfe erroCalculoBtn"
                        style={{ marginTop: 25, marginRight: 25 }}
                      >
                        {this.obs.showSuccess ? "Ocultar" : "Mostrar"} importados
                      </MDBBtn> : <>
                      </>
                    }
                  </div>
                </MDBCol>

                <MDBCol md="7">
                  <div className="import-collapse-area">
                    <Collapse isOpen={this.obs.showErrors}>
                      <div className="flash-error" style={{ maxHeight: 400 }}>
                        {this.obs.resp_data.total_erros &&
                          <>
                            <div className="import-status-header">
                              <img
                                src="/images/erro_calculo.svg"
                                width={50}
                                className="inline-img"
                              />
                              <h3>Erros foram encontrados</h3>
                            </div>

                            <div className="import-scroll-area">
                              {this.obs.resp_data.erros.map(e => {

                                return (<p>{e}</p>)

                              })}
                            </div>

                          </>
                        }
                      </div>
                    </Collapse>
                    <Collapse isOpen={this.obs.showSuccess}>
                      <div className="flash-error" style={{ maxHeight: 400 }}>
                        {this.obs.resp_data.importados &&
                          <>
                            <div className="import-status-header">
                              <img
                                src="/images/pass_calculo.png"
                                width={50}
                                className="inline-img"
                              />
                              <h3 className="success-title">Empresas cadastradas com sucesso</h3>
                            </div>

                            <div className="import-scroll-area">
                              {this.obs.resp_data.criados.map(e => {

                                return (<p>{e}</p>)

                              })}
                            </div>

                          </>
                        }
                      </div>
                    </Collapse>
                  </div>
                </MDBCol>
              </MDBRow>
            </div>
            <div className={Classes.DIALOG_FOOTER}>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <Button text="Fechar" onClick={() => { this.obs.detalhes_import_planilha = false; this.obs.showErrors = false; this.obs.showSuccess = false }} />
              </div>
            </div>
          </Dialog>

          <LoadingModal open={EmpresaStore.obs.loading_import} onClose={() => EmpresaStore.obs.loading_import = false} title={"Importando planilha"} />

        </div>

      </>
    );
  }
}

const tourConfig = [
  {
    selector: "[data-tut=\"faturamento\"]",
    content: "Informe aproximadamente o faturamento da empresa que deseja cadastrar. ",
  },
  {
    selector: "[data-tut=\"plano\"]",
    content: "O plano é calculado automaticamente com base no seu rendimento. ",
  },
  {
    selector: "[data-tut=\"cnpj\"]",
    content: "Digite o CNPJ da Empresa que deseja Cadastrar. ",
  },
  {
    selector: "[data-tut=\"continuar\"]",
    content: "Clique em Continuar para prosseguir com o cadastro. ",
  },
];

const tourTestConfig = [
  {
    selector: "[data-tut=\"faturamento_teste\"]",
    content: "Durante o período de teste, o sistema adota automaticamente o plano da Faixa 1 como padrão. ",
  },
  {
    selector: "[data-tut=\"cnpj\"]",
    content: "Digite o CNPJ da Empresa que deseja Cadastrar. ",
  },
  {
    selector: "[data-tut=\"continuar\"]",
    content: "Clique em Continuar para prosseguir com o cadastro. ",
  },
];